import { INeoAction } from '../../Actions.interface';
import { STATUS, REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { IBookingGroup } from '~/Models/DTO/BookingGroup.model';
import { IErrorResponse } from '~/Models/DTO/Error.models';

export interface BookingGroupState {
  list: IBookingGroup[];
  loading: boolean;
  error: IErrorResponse | null;
}

const INITIAL: BookingGroupState = {
  list: [],
  loading: false,
  error: null,
};

export default (state: BookingGroupState = INITIAL, action: INeoAction): BookingGroupState => {
  const { status, payload, name } = action;

  if (name !== REQUEST_ACTIONS.BOOKING_GROUPS) {
    return state;
  }
  switch (status) {
    case STATUS.SUCCESS:
      return {
        list: payload,
        loading: false,
        error: null,
      };
    case STATUS.FAILURE:
      return {
        list: [],
        loading: false,
        error: payload,
      };
    case STATUS.LOADING:
      return {
        list: [],
        loading: true,
        error: null,
      };
  }

  return state;
};
